import React from "react";

import { CATALOG_TEXT } from "./catalogText";

const PAGER_BTN = "rounded-lg border border-[#EBECE6] bg-white px-3 py-1.5 text-sm font-semibold text-gray-600 disabled:opacity-40";

/** "from–to of total" with Previous / Next over pages of `limit`; `children` go beside the buttons (e.g. a page size). */
export default function CatalogPager({ offset, limit, total, shown, onOffset, children }) {
  const from = total ? offset + 1 : 0;
  const to = Math.min(offset + (shown === undefined ? limit : shown), total);
  return (
    <nav className="mt-6 flex flex-wrap items-center justify-between gap-3 text-sm text-gray-500" aria-label={CATALOG_TEXT.paging.label}>
      <span>{CATALOG_TEXT.paging.range(from, to, total)}</span>
      <span className="flex flex-wrap items-center gap-2">
        {children}
        <button type="button" className={PAGER_BTN} disabled={offset === 0}
          onClick={() => onOffset(Math.max(0, offset - limit))}>{CATALOG_TEXT.paging.previous}</button>
        <button type="button" className={PAGER_BTN} disabled={offset + limit >= total}
          onClick={() => onOffset(offset + limit)}>{CATALOG_TEXT.paging.next}</button>
      </span>
    </nav>
  );
}
